'use client';
import { sendGTMEvent } from '../sendGTMEvent';

/**
 * Tracks search events with a 1000ms delay to prevent inflation.
 * 
 * This function implements a debounced search tracking mechanism that waits
 * for 1000ms after the last search input before firing the event. This prevents
 * multiple events from being fired for rapid typing.
 * 
 * @param searchTerm - The search term entered by the user
 * @param searchType - The type of search (defaults to 'search_bar')
 */
export const trackSearch = (() => {
  let searchTimeout: NodeJS.Timeout;
  
  return (searchTerm: string, searchType: string = 'search_bar') => {
    // Clear any existing timeout
    clearTimeout(searchTimeout);
    
    // Set a new timeout for 1000ms
    searchTimeout = setTimeout(() => {
      sendGTMEvent({
        event: 'search',
        search_term: searchTerm,
        search_type: searchType,
      });
    }, 1000);
  };
})();